var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "locale-changer" }, [
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.locale,
            expression: "locale",
          },
        ],
        on: {
          change: function ($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function (o) {
                return o.selected
              })
              .map(function (o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.locale = $event.target.multiple
              ? $$selectedVal
              : $$selectedVal[0]
          },
        },
      },
      _vm._l(_vm.locales, function (label, lang) {
        return _c(
          "option",
          { key: `locale-${lang}`, domProps: { value: lang } },
          [_vm._v("\n            " + _vm._s(label) + "\n        ")]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }